import { CHECKOUT_URL, PRICE, CURRENCY } from '../data/config';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

// Every button except the one inside the offer section only scrolls to the offer.
export function scrollToOffer() {
  if (typeof document === 'undefined') return;
  document.getElementById('offer')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// Copies utm_* and fbclid from the current page URL onto the checkout URL.
export function buildCheckoutUrl(): string {
  if (typeof window === 'undefined' || !CHECKOUT_URL) return CHECKOUT_URL;
  try {
    const target = new URL(CHECKOUT_URL);
    const current = new URLSearchParams(window.location.search);
    current.forEach((value, key) => {
      const k = key.toLowerCase();
      if ((k.startsWith('utm_') || k === 'fbclid') && !target.searchParams.has(key)) {
        target.searchParams.set(key, value);
      }
    });
    return target.toString();
  } catch {
    return CHECKOUT_URL;
  }
}

// ONLY used by the offer button.
export function goToCheckout() {
  if (typeof window === 'undefined') return;
  try {
    window.fbq?.('track', 'InitiateCheckout', { value: PRICE, currency: CURRENCY });
  } catch {
    /* pixel not loaded */
  }
  if (!CHECKOUT_URL) {
    scrollToOffer();
    return;
  }
  window.location.href = buildCheckoutUrl();
}
